import React from 'react';
import PropTypes from 'prop-types';

/**
 * Control - A wrapper that renders a standard HTML div with Bulma class names
 * 
 * This component accepts the same props as Bloomer Control for easy migration
 */
const Control = ({
  className = '',
  children = null,
  style = {},
  tag: Tag = 'div',
  hasIcons = false,
  isExpanded = false,
  isLoading = false,
  ...props
}) => {
  // Build the class names based on props
  const getClassNames = () => {
    const classes = ['control'];
    
    // Add appropriate classes based on props
    if (hasIcons) {
      if (typeof hasIcons === 'string') {
        classes.push(`has-icons-${hasIcons}`);
      } else {
        classes.push('has-icons');
      }
    }
    
    if (isExpanded) {
      classes.push('is-expanded');
    }
    
    if (isLoading) {
      classes.push('is-loading');
    }
    
    // Add custom class names
    if (className) {
      classes.push(className);
    }
    
    return classes.join(' ');
  };

  return (
    <Tag
      className={getClassNames()}
      style={style}
      {...props}
    >
      {children}
    </Tag>
  );
};

// eslint-disable-next-line react/require-default-props
Control.propTypes = {
  className: PropTypes.string,
  style: PropTypes.object,
  children: PropTypes.node,
  tag: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.func,
    PropTypes.object
  ]),
  hasIcons: PropTypes.oneOfType([
    PropTypes.bool,
    PropTypes.string
  ]),
  isExpanded: PropTypes.bool,
  isLoading: PropTypes.bool,
};



export default Control;
